type JSONString = string;

export interface CommunicationsDataset {
  communications?: JSONString;
}

export interface SiteCommunicationsDataset extends CommunicationsDataset {
  object_id?: string;
  subscribe_to?: string;
}

export interface TimeWindow {
  startTime: string; // Format HH:mm
  endTime: string; // Format HH:mm
  timezone: string; // e.g., 'Europe/Paris', 'America/New_York'
}

export interface DatasetCommunication {
  _id: string;
  zones: string[];
  startAt: string;
  endAt: string;
  horizontalFilename?: string;
  verticalFilename?: string;
  duration: number;
  orderingName?: string;
  disabledSites?: string[];
  timeWindow?: TimeWindow;
}

export enum CommunicationsFilteringMode {
  ALL = 'all',
  MY_ZONES_ONLY = 'my-zones-only',
  WITHOUT_ZONES_ONLY = 'without-zones-only',
}
